import { render, staticRenderFns } from "./SpatieFilter.vue?vue&type=template&id=65f199f0&scoped=true&"
import script from "./SpatieFilter.vue?vue&type=script&lang=js&"
export * from "./SpatieFilter.vue?vue&type=script&lang=js&"
import style0 from "./SpatieFilter.vue?vue&type=style&index=0&id=65f199f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f199f0",
  null
  
)

export default component.exports